/**
 * Created by Ivan on 24.05.2025
 */

const DogStreakTutorial = function () {
    return new TutorialScenario(DogStreakTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(DogStreakTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(DogStreakTutorial.NAME);
            Game.currentGame.hand.setCards(DogStreakTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(DogStreakTutorial.NAME)
    });
};

DogStreakTutorial.NAME = "dogStreak";
DogStreakTutorial.CONFIG = {
    handValues: ["5"],
    importantCards: [StreakCard],
    force: "DogStreakTutorialMessage",
    filter: ["4", StreakCard]
};
